/* Predictive search: Shopify /search/suggest.json with grouped results
   (products, collections, articles, pages). Debounced dropdown.
   Initializes every [data-predictive-wrap] (desktop header + mobile drawer). */

(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function init(wrap) {
    var input = wrap.querySelector('[data-predictive-input]');
    var panel = wrap.querySelector('[data-predictive-panel]');
    if (!input || !panel) return;

    var timer = null;
    var lastQuery = '';

    function hide() { panel.hidden = true; panel.innerHTML = ''; }

    function render(data, q) {
      var r = data.resources.results;
      var groups = [
        { key: 'products', label: 'Products' },
        { key: 'collections', label: 'Categories' },
        { key: 'articles', label: 'Articles' },
        { key: 'pages', label: 'Pages' }
      ];
      var html = '';
      groups.forEach(function (g) {
        var items = r[g.key] || [];
        if (!items.length) return;
        html += '<div class="predictive__group"><p class="predictive__label">' + g.label + '</p>';
        items.slice(0, 5).forEach(function (item) {
          var img = item.featured_image && item.featured_image.url
            ? '<img src="' + item.featured_image.url + '&width=80" alt="" width="40" loading="lazy">'
            : (item.image ? '<img src="' + item.image + '" alt="" width="40" loading="lazy">' : '');
          var price = item.price ? '<span class="predictive__price">$' + item.price + '</span>' : '';
          html += '<a class="predictive__item" href="' + item.url + '">' + img +
            '<span class="predictive__title">' + item.title + '</span>' + price + '</a>';
        });
        html += '</div>';
      });
      if (!html) {
        html = '<p class="predictive__none">No results for &ldquo;' + q.replace(/</g, '&lt;') + '&rdquo;</p>';
      } else {
        html += '<a class="predictive__all" href="' + root + 'search?q=' + encodeURIComponent(q) + '">See all results &rarr;</a>';
      }
      panel.innerHTML = html;
      panel.hidden = false;
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { hide(); return; }
      timer = setTimeout(function () {
        lastQuery = q;
        fetch(root + 'search/suggest.json?q=' + encodeURIComponent(q) +
              '&resources[type]=product,collection,page,article&resources[limit]=5&resources[options][unavailable_products]=last')
          .then(function (res) { return res.json(); })
          .then(function (data) { if (q === lastQuery) render(data, q); })
          .catch(hide);
      }, 200);
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-predictive-wrap]')) hide();
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') hide();
    });
  }

  document.querySelectorAll('[data-predictive-wrap]').forEach(init);
})();
